module.exports = __webpack_public_path__ + "static/media/3.ec05f092.png";